import { render, staticRenderFns } from "./Fleet.vue?vue&type=template&id=1bd976f5&lang=pug&"
import script from "./Fleet.vue?vue&type=script&lang=ts&"
export * from "./Fleet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports